import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Table from '../../../Extracomponents/Table';
import { Eye, Pencil, Trash2, IndianRupee } from 'lucide-react';
import { DeleteStockRating, CouponStatus, CouponShowstatus, GetService, GetStocklistbyadmin } from '../../../Services/Admin/Admin';
import { image_baseurl } from '../../../../Utils/config';
import { Tooltip } from 'antd';
import { fDate, fDateTime } from '../../../../Utils/Date_formate';
import Loader from '../../../../Utils/Loader';
import ReusableModal from '../../../components/Models/ReusableModal';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';


const Stockrating = () => {


    const navigate = useNavigate();

    const [clients, setClients] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [viewpage, setViewpage] = useState({});
    const [datewise, setDatewise] = useState("")

    const [service, setService] = useState([])

    const [isLoading, setIsLoading] = useState(true)

    const token = localStorage.getItem('token');



    const getstocklist = async () => {
        try {
            const response = await GetStocklistbyadmin(token);
            if (response.status) {
                const filterdata = response.data.filter((item) =>
                    searchInput === "" ||
                    item.symbol.toLowerCase().includes(searchInput.toLowerCase())
                );
                setClients(searchInput ? filterdata : response.data);
                setDatewise(response.data)

            }
        } catch (error) {
            console.log("error");
        }

        setIsLoading(false)

    }






    useEffect(() => {
        getstocklist();
    }, [searchInput]);




    const updatestock = async (row) => {
        navigate("/admin/stockrating/updaterating/" + row._id, { state: { row } })
    }


    const DeleteStockbyadmin = async (_id) => {
        try {
            const result = await showCustomAlert("confirm", 'Do you want to delete this stock This action cannot be undone.')

            if (result.isConfirmed) {
                const response = await DeleteStockRating(_id, token);
                if (response.status) {
                    showCustomAlert("Success", 'The stock rating has been successfully deleted.')
                    getstocklist();

                }
            } else {
                showCustomAlert("error", 'The stock deletion was cancelled.')
            }
        } catch (error) {
            showCustomAlert("error", 'There was an error deleting the stock.')
        }
    };



    const columns = [

        {
            name: 'symbol',
            selector: row => row.symbol,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Financial',
            selector: row => row.financial,
            sortable: true,
            width: '200px',
        },
        {
            name: 'Over All',
            selector: row => row.overall,
            sortable: true,
            width: '200px',
        },
        {
            name: 'Technicals',
            selector: row => row.technicals,
            sortable: true,
            width: '200px',
        },
        {
            name: 'Trust',
            selector: row => row.trust,
            sortable: true,
            width: '200px',
        },
        {
            name: 'Valuation',
            selector: row => row.valuation,
            sortable: true,
            width: '200px',
        },
        {
            name: 'Actions',
            cell: row => {
                return (
                    <>


                        <div className='d-flex' >
                            <div>
                                <Tooltip placement="top" overlay="Edit">
                                    <Pencil onClick={() => updatestock(row)} />
                                </Tooltip>
                            </div>
                            <div>
                                <Tooltip placement="top" overlay="Delete">
                                    <Trash2 onClick={() => DeleteStockbyadmin(row._id)} />
                                </Tooltip>
                            </div>
                        </div>

                    </>
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }

    ];

    return (
        <div>
            <div>
                <div className="page-content">
                    <div className="page-breadcrumb  d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Stock Rating</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/admin/dashboard">
                                            <i className="bx bx-home-alt" />
                                        </Link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            <div className="d-lg-flex align-items-center mb-4 gap-3">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control ps-5 radius-10"
                                        placeholder="Search stock"
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        value={searchInput}
                                    />
                                    <span className="position-absolute top-50 product-show translate-middle-y">
                                        <i className="bx bx-search" />
                                    </span>
                                </div>
                                <div className="ms-auto">
                                    <Link
                                        to="/admin/addrating"
                                        className="btn btn-primary"
                                    >
                                        <i
                                            className="bx bxs-plus-square"
                                            aria-hidden="true"
                                        />
                                        Add Stock Rating
                                    </Link>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {isLoading ? (
                    <Loader />
                ) : (
                    <>

                        <Table
                            columns={columns}
                            data={clients}
                        />
                    </>
                )}




            </div>
        </div>
    );
}

export default Stockrating;
